module.exports = __webpack_public_path__ + "static/media/nutricia-product-scoop-chart-2024-august-ire.298597c0.pdf";